export function ChevronLeftIcon({ className }: { className?: string }) {
  return (
    <div style={{ padding: "4px" }}>
      <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 7 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.292787 4.89007L4.88579 0.297071C4.97737 0.203616 5.08658 0.129244 5.20708 0.0782559C5.32759 0.0272673 5.45701 0.000673496 5.58786 1.26278e-05C5.71871 -0.00064824 5.84839 0.0246367 5.9694 0.0744054C6.09042 0.124174 6.20037 0.197439 6.29289 0.289964C6.38542 0.382489 6.45868 0.492439 6.50845 0.613455C6.55822 0.73447 6.58351 0.864152 6.58284 0.995C6.58218 1.12585 6.55559 1.25527 6.5046 1.37578C6.45361 1.49628 6.37924 1.60549 6.28579 1.69707L2.38579 5.59707L6.28579 9.49707C6.46835 9.68336 6.57002 9.93417 6.5687 10.195C6.56739 10.4558 6.46319 10.7056 6.27875 10.89C6.09432 11.0745 5.84454 11.1787 5.58372 11.18C5.32289 11.1813 5.07208 11.0796 4.88579 10.8971L0.292787 6.30507C0.105316 6.11754 0 5.86324 0 5.59807C0 5.33291 0.105316 5.0786 0.292787 4.89107V4.89007Z"
          fill="currentColor"
          fillOpacity="0.28"
        />
      </svg>
    </div>
  );
}
